<div class="filter-close-container">
    <div>
        <img alt="back" (click)="handleBack()" class="cursor" src="../../../../assets/images/arrow_circle_left.svg" />&nbsp; <span class="geo-title">Geo Trace - Trip History</span>
    </div>
    <div class="d-flex align-items-center gap-10">
      <div *ngIf="sharedService.rbacManagement('entities_GeoFence')">
        <button class="geo-fence-button uni-geo-fence-bt" (click)="enableDrawControls()">{{ !showControls ? 'Geo-fence' : 'Trip
          history' }}</button>
      </div>
      <!-- <div
        class="filter-drop-down period route-filter fit-content -mat-select-height-unset -border-bottom-none calendar-geo-fence"
        *ngIf="!showControls">
        <mat-form-field appearance="outline" class="mw-150 route-date-picker-alignement">
          <input matInput [matDatepicker]="dp3" placeholder="Date" [formControl]="datePicker" [readonly]="true"
            (dateChange)="dateChange($event)" [min]="minDate" [max]="maxDate">
          <mat-datepicker-toggle matSuffix [for]="dp3">
            <mat-icon matDatepickerToggleIcon>
              <img src="../../../../assets/images/icon-calendar.svg" alt="calendar" title="calendar">
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field>
      </div> -->
      <div *ngIf="!showControls"> 
        <form [formGroup]="datepickerForm">
          <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
            [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
            [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" 
            [opens]="'left'" (datePassed)="saveTime($event)">
          </app-datetime-range>
          </form>
      </div>
      <!-- <div class="pop-close">
        <img src="../../../../assets/images/dover-close-icon.svg" alt="close" class="h-30 cursor" title="close"
          mat-dialog-close>
      </div> -->
    </div>
  </div>
  <div class="make-responsive-vehicle-graphics">
    <app-leaflet-map pageType="profile" [mapData]="masterMapData" [showControls]="showControls" [popOver]="true" [showStartEnd]="true"
      class="w-100" (drawZoneAction)="geoFenceValues($event)" styleType="full">
    </app-leaflet-map>
    <div *ngIf="!showControls">
      <div class="d-flex justify-space-between mb-2">
        <div class="vehicle-detail">
          <div class="d-flex details-box">
            <div class="position-relative mt-3">
              <img *ngIf="entityDetails?.image && imageLoaded" src="{{ entityDetails?.image }}" class="v-image" [alt]="entityDetails?.category" (load)="onImageLoad()"
              (error)="onImageError()">
              <img *ngIf="!entityDetails?.image || !imageLoaded" [src]="defaultImage" class="v-image" [alt]="entityDetails?.category">
            </div>
            <div>
              <div class="category-chips"><span class="geo-chip">{{entityDetails?.category}}</span> <span class="geo-chip">{{entityDetails?.secondaryDetails?.type | titlecase}}</span></div>
              <div class="entity-name">{{entityDetails?.uniqueId}}</div>
            </div>
          </div>
        </div>
        <div class="cursor" (click)="geoTracePlayback()" *ngIf="sharedService?.rbacManagement('vehicles_Enrolled_GeoTracePlayback') && activeDates?.length">
          <span class="trips-title">Trips</span> &nbsp;<img src="../../../../assets/images/Geo-Playback.svg" alt="">
        </div>
        <div class="cursor" (click)="geoTracePlaybackV2()" *ngIf="sharedService?.rbacManagement('vehicles_Enrolled_GeoTracePlaybackV2')  && activeDates?.length">
          <span class="trips-title">Trips</span> &nbsp;<img src="../../../../assets/images/Geo-Playback.svg" alt="">
        </div>
      </div>
      <div class="trip-history" *ngIf="activeDates?.length">
        <app-trip-history class="cursor" *ngFor="let date of activeDates; let i = index; let count = count"  [entityId]="entityId" [date]="date" [entityName]="entityDetails?.uniqueId" [insightsAvailable]="isInsightAvailable(getTripId(date))" [tripName]="getTripLabel(date, i, count)" [tripId]="getTripId(date)" (click)="tripSelected(i)" [isTripSelected]="selectedTripIndex===i" [entityDetails]="entityDetails"></app-trip-history>
      </div>
      <app-trip-history *ngIf="!activeDates?.length" [entityId]="entityId" [date]="selectedDate" [entityName]="entityDetails?.uniqueId" [tripName]="null" [entityDetails]="entityDetails"></app-trip-history>
    </div>
    <app-geo-trace-zone-details *ngIf="showControls"></app-geo-trace-zone-details>
  </div>